/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const chatErrorDataSchema = z.object({
	error: z.string(),
	type: z.string(),
})

export type ChatErrorDataSchema = z.infer<typeof chatErrorDataSchema>
